import React, { useContext } from 'react'
import { ReportingContext } from '../../../wrappers/ReportingContext'

const InfoPopup = () => {
    const { info, setInfo } = useContext(ReportingContext)

    const handleClose = () => {
        setInfo(prevInfo => ({...prevInfo, display: false}))
    }
    
    return (
        <div className={`popup ${info && info.display ? '' : 'hidden'}`}>
            <div className="popupContent">
                <div className="popupHeader">
                    Data Source Information
                </div>
                <div className="popupFooter">
                    <button className="button is-primary" onClick={handleClose}>Close</button>
                </div>
            </div>
        </div>
    )
}

export default InfoPopup